import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';
class FixedAssetCategoryCategoryAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'FixedAssetCategorys';
  /**
   * lấy số cấp cao nhất của danh mục Loại tài sản cố định
   * ddthang 26/12/2022
   */
  getMaxGrade() {
    let request = { url: this.getAPIUrl() + '/maxGrade' };
    return httpClient.getAsync(request);
  }
  /**
   * Lấy danh sách các loại tài sản con khi chọn loại tài sản cha
   * @param {*} payload
   * @returns
   */
  getChilds(payload) {
    let request = {
      url: this.getAPIUrl() + '/categoryChilds',
      data: payload,
    };

    return httpClient.getAsync(request);
  }
}

export default new FixedAssetCategoryCategoryAPI();
